import {Directive, Injector, OnDestroy} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {TitleService} from "@shared/services";
import {SnackbarFactory} from '@shared/services';
import {AuthService} from '@shared/services';

/**
 * @deprecated Only kept alive to maintain support for older shared components. Don't extend this class!
 */
@Directive()
export abstract class FuncBaseDirective implements OnDestroy {
  protected ngUnsubscribe: Subject<any> = new Subject();

  protected snackBar: SnackbarFactory;
  protected auth: AuthService;
  protected titleService: TitleService;
  protected translateService: TranslateService;

  protected constructor(protected injector: Injector, public titleName: string = '') {
    this.snackBar = this.injector.get(SnackbarFactory);
    this.auth = this.injector.get(AuthService);
    this.titleService = this.injector.get(TitleService);
    this.translateService = this.injector.get(TranslateService);

    if (titleName && titleName !== '') {
      this.titleService.setTitle(titleName);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.complete();
  }

  public hasRight(right): boolean {
    return this.auth.isAuthenticated(right);
  }

  public hasNoRight(right): boolean {
    return !this.hasRight(right);
  }
}
